import api from './client'

export interface Zone {
  id: string
  name: string
  zone_type: 'reservoir_catchment' | 'pipeline_branch' | 'water_source'
  description: string | null
  scada_device_id: string | null
  active: boolean
  meter_count: number
  created_at: string
}

export const ZONE_TYPE_LABEL: Record<string, string> = {
  reservoir_catchment: 'Slivno područje',
  pipeline_branch:     'Grana cevovoda',
  water_source:        'Vodozahvat',
}

// reservoir_catchment was generic Tailwind blue-800, not the brand cyan
// text tone — same off-brand-blue bug class as the RoleBadge/text-blue-700
// fixes in docs/plan-shared-design-tokens.md, caught while consolidating
// the "info chip" pattern into a shared Badge component.
export const ZONE_TYPE_COLOR: Record<string, string> = {
  reservoir_catchment: 'bg-blue-100 text-brand-cyan-text',
  pipeline_branch:     'bg-teal-100 text-teal-800',
  water_source:        'bg-emerald-100 text-emerald-800',
}

export const zonesApi = {
  list: (params?: { zone_type?: string; active_only?: boolean }) =>
    api.get<Zone[]>('/zones', { params }),

  create: (body: { name: string; zone_type: string; description?: string }) =>
    api.post<Zone>('/zones', body),

  // description accepts null (not just omission) -- PATCH /zones/{id}
  // switched to exclude_unset (meters-to-web-2026-09-21-patch-clear-
  // nullable.md): an omitted key now means "leave alone," so clearing it
  // has to send an explicit null, not undefined.
  update: (id: string, body: { name?: string; zone_type?: string; description?: string | null; active?: boolean }) =>
    api.patch<Zone>(`/zones/${id}`, body),
}
